<template>
	<div class="not-found">
		<v-row>
			<v-col cols="12" class="text-center">
				<div>
					<img width="400" src="/assets/icon/ilus-page-not-found.svg">
				</div>
				<div class="pt-1-rem font-size-2-rem font-weight-bold color-grey">Waduh, Anda menemukan halaman 404 pada website Kami</div>
				<div class="pt-2 color-grey">Jangan khawatir, semua akan baik - baik saja</div>
				<div class="pt-1 color-grey">Silakan kembali melakukan transaksi dengan klik tombol di bawah ini</div>
				<div class="pt-1-rem">
					<router-link to="/" class="text-deco">
						<v-btn width="200" depressed large class="bg-purple">Kembali</v-btn>
					</router-link>
				</div>
			</v-col>
		</v-row>
	</div>
</template>
<script>
export default {
	created() {
		this.$store.dispatch('setPageTitle', `404`)
	}
}
</script>

<style>
.not-found {
	font-family: "Roboto", sans-serif !important;
}
.text-center {
	text-align: center;
}
.font-size-2-rem {
	font-size: 2rem;
}
.font-italic {
	font-style: italic;
}
.font-weight-bold {
	font-weight: bold;
}
.pt-1 {
	padding-top: 4px;
}
.pt-2 {
	padding-top: 8px;
}
.pt-1-rem {
	padding-top: 1rem;
}
.color-grey {
	color: grey;
}
.bg-purple {
	background-color: #512DA8 !important;
	color: white !important;
}
.text-deco {
	text-decoration: none;
}
</style>